// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4116":"5b2c0765","9688":"5b2c0765"}[chunkId] + ".chunk.css";
};